// This needs to be globally unique, to make sure React re-renders
// parameter rows from scratch for different components
export const getComponentParameterKey = (
  componentInstanceId: number,
  parameterId: string
) => `${componentInstanceId}.${parameterId}`
